import { GetAdditionalProgressionFlowsAvailableForJobRequest } from '@taxfyle/api-internal/internal/job_progression_pb'
import { collection } from '@/infra/collection'
import { Id } from '@/infra/id'
import { AvailableJobProgressionFlows } from './AvailableJobProgressionFlows'
import type { JobsApi } from '@/features/jobs/api/job-api'
import { mapAvailableJobProgressionFlowsResponseProtoToProps } from './available-job-progression-flows-mappers'

export class AvailableJobProgressionFlowsStore {
  /**
   * Available progression flows by job ID.
   */
  readonly availableJobProgressionFlows = collection({
    create: () => new AvailableJobProgressionFlows(),
    getModelId: (p) => p.jobId,
    getDataId: (p) => p.jobId,
  })

  constructor(private readonly _api: JobsApi) {}

  /**
   * Looks up the available progression flows of a job.
   *
   * @param jobId
   */
  availableProgressionFlowsForJob(
    jobId: Id,
  ): AvailableJobProgressionFlows | undefined {
    return this.availableJobProgressionFlows.get(jobId)
  }

  /**
   * Fetches the available progression flows of a job.
   *
   * @param jobId
   * @param signal
   */
  async fetchAvailableJobProgressionFlows(jobId: Id, signal?: AbortSignal) {
    const id = Id.assert(jobId)
    const request =
      new GetAdditionalProgressionFlowsAvailableForJobRequest().setJobId(id)

    const response =
      await this._api.progressions.getAdditionalProgressionFlowsAvailableForJob(
        request,
      )
    signal?.throwIfAborted()

    this.availableJobProgressionFlows.set(
      mapAvailableJobProgressionFlowsResponseProtoToProps(response, id),
    )
  }
}
